// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"b34a7334","453":"54292a4b","455":"658c1809","977":"b584b783"}[chunkId] + ".chunk.js";
};